import * as semver from 'semver';

class ExtensionManagerImpl {
    getExtensions(point) {
        var _this_contributions_get;
        // get all configs for this extension point
        return ((_this_contributions_get = this.contributions.get(point.id)) == null ? void 0 : _this_contributions_get.map((p)=>p.config)) || [];
    }
    contributeExtension(point, extension) {
        var _this_contributions_get, // save the extension with all configurations
        _this_contributions_get1;
        // Extension point must be registered first in order for extension to be contributed
        if (!this.registrations.get(point.id)) {
            throw new Error(`Extension point ${point.id} is not defined.`);
        }
        // validate the version compatibility of the extension point
        // first validate the semver version and range correctness
        const registeredPoint = this.registrations.get(point.id);
        if (!(registeredPoint == null ? void 0 : registeredPoint.version) || !semver.valid(registeredPoint.version)) {
            throw new Error(`This should not happen: Registered EP ${registeredPoint == null ? void 0 : registeredPoint.id} has invalid version ${registeredPoint == null ? void 0 : registeredPoint.version}. Contact UI Platform team.`);
        }
        // then validate the semver range correctness
        if (!(registeredPoint == null ? void 0 : registeredPoint.compatibilityRange) || semver.validRange(registeredPoint.compatibilityRange) === null) {
            throw new Error(`This should not happen: Registered EP ${registeredPoint.id} has invalid compatibilityRange ${registeredPoint.version}. Contact UI Platform team.`);
        }
        // validate the semver compatibility of the extension point version with the registered version
        if (!semver.satisfies(new semver.SemVer(point.version), new semver.Range(registeredPoint.compatibilityRange))) {
            throw new Error(`Extension version ${point.version} is not compatible with registered extension point ${registeredPoint.id} version ${registeredPoint.version} (compatible range: ${registeredPoint.compatibilityRange}).`);
        }
        // validate unique IDs of contributed configurations
        const ids = new Set((_this_contributions_get = this.contributions.get(point.id)) == null ? void 0 : _this_contributions_get.map((p)=>p.id));
        if (ids.has(extension.id)) {
            throw new Error(`Extension ID ${extension.id} is already in use. Either create different id or verify already contributed extensions`);
        }
        if (!point.validator || !point.validator.validate) {
            throw new Error(`Extension point ${point.id} does not have a valid validator or validate function.`);
        }
        // validate the runtime correctness of the configuration schema with RuntimeValidator
        const validationResult = point.validator.validate(extension.config);
        if (!validationResult.success) {
            throw new Error(`Invalid configuration: ${validationResult.error}`);
        }
        // check the contribution in the singleton extension point, fail if it is not
        const pointContributions = this.contributions.get(point.id);
        if (point.isSingleton && Array.isArray(pointContributions) && pointContributions.length > 0) {
            throw new Error(`Singleton extension can only have one contribution. Some contribution already exists for extension point ${point.id}.`);
        }
        (_this_contributions_get1 = this.contributions.get(point.id)) == null ? void 0 : _this_contributions_get1.push(extension);
    }
    registerExtensionPoint(point) {
        // check if the extension point is already registered
        if (this.registrations.has(point.id)) {
            throw new Error(`Extension point ${point.id} is already registered.`);
        }
        // check the semver correctness of the version and compatibilityRange
        if (!semver.valid(point.version) || !semver.validRange(point.compatibilityRange)) {
            throw new Error(`Extension point ${point.id} has invalid version or compatibilityRange.`);
        }
        // add the registered extension point
        this.registrations.set(point.id, point);
        // and make sure contribution is initialised with empty array
        this.contributions.set(point.id, []);
    }
    constructor(){
        this.registrations = new Map();
        this.contributions = new Map();
    }
}

function ZodValidatorFactory(schema) {
    let Validator = class Validator {
        validate(config) {
            const result = schema.safeParse(config);
            if ('error' in result) {
                var _result_error;
                return {
                    success: false,
                    error: (_result_error = result.error) == null ? void 0 : _result_error.message
                };
            }
            return {
                success: true
            };
        }
    };
    return new Validator();
}

export { ExtensionManagerImpl, ZodValidatorFactory };
